"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESTATUS_DID = void 0;
exports.ESTATUS_DID = {
    INACTIVO: 0,
    DISPONIBLE: 1,
    PORTADO_A_OTRA_EMPRESA: 2,
    ASIGNADO: 3,
};
